import { Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material';

// No hay muchas maneras de hacer esto mas legible. Quiza se podria picar en
// el StyledTooltip y otro componente que acepte el disabled y renderice
// no vale la pena ahora mismo porque no hay mas casos de uso

/**
 * A styled tooltip that can be disabled.
 * if disabled is true, it will render the children without the tooltip wrapper
 *
 * @example - disabled
 * <StyledTooltip title="Disabled tooltip" disabled>
 *  <Button>Disabled tooltip</Button>
 * </StyledTooltip>
 *
 * @example - enabled
 * <StyledTooltip title="Enabled tooltip">
 *   <Button>Enabled tooltip</Button>
 * </StyledTooltip>
 */
export const StyledTooltip = styled(
  ({
    className,
    disabled,
    children,
    ...props
  }: TooltipProps & { disabled?: boolean }) =>
    disabled ? (
      children
    ) : (
      <Tooltip
        {...props}
        // eslint-disable-next-line react/no-children-prop
        children={children}
        classes={{ popper: className }}
        slotProps={{
          popper: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, -8],
                },
              },
            ],
          },
        }}
      />
    )
)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#21005D',
    fontSize: '.85rem',
    minHeight: '1.5rem',
    display: 'flex',
    alignItems: 'center',
  },
}));
